import { TestId } from "../testIdType"

export const testId: TestId = {
    accordion: "accordion",
    accordionToggle: "accordion-toggle",
    btnClose: "btn-close",
    cancelButton: "cancelButton",
    collapser: "collapser",
    collapseSidebar: "collapse-sidebar",
    datePicker: "date-picker",
    datePickerIcon: "date-picker-icon",
    datePickerInput: "date-picker-input",
    datePickerPreset: "date-picker-preset",
    draggableButton: "draggable-button",
    dropdownItem: "dropdown-item",
    dropdownToggle: "dropdown-toggle",
    fileUploaderInput: "file-uploader-input",
    indicatorIconClearValue: "indicator-icon-clear-value",
    leftSidebar: "left-sidebar",
    loader: "loader",
    loadingButton: "loading-button",
    radioButtonValidatableInput: "radio-button-validatable-input",
    scrollDownButton: "scroll-down-button",
    scrollUpButton: "scroll-up-button",
    searchInput: "search-input",
    searchInputClearButton: "search-input-clear-button",
    selectFile: "select-file",
    settingsButton: "settings-button",
    sidebarActionButton: "sidebar-action-button",
    submitButton: "submitButton",
    tab: "tab",
    tabBaseLink: "tab-base-link",
    tag: "tag",
    tagCloseButton: "tag-close-button",
    tagInput: "tag-input",
    toNextPage: "to-next-page",
    toPreviousPage: "to-previous-page"
}
